import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { SessionUser } from '@/api/profile/types';
import { clearTablePreferences } from '@/hooks/useTablePreferences';
import { useUploadStore } from '@/store/uploadStore';

interface SessionState {
  user: SessionUser | null;
  setUser: (user: SessionUser) => void;
  clearUser: () => void;
}

export const useSessionStore = create<SessionState>()(
  persist(
    set => ({
      user: null,
      setUser: user => {
        const upload = useUploadStore.getState();
        if (upload.userId !== null && upload.userId !== user.id) {
          upload.clearAll();
          clearTablePreferences();
        }
        upload.setUserId(user.id);
        set({ user });
      },
      clearUser: () => set({ user: null }),
    }),
    {
      name: 'session-store',
      partialize: state => ({ user: state.user }),
    },
  ),
);
